enum ThirdUserTypes {
    carrierOperator = 0,
    carrierAdmin = 1,
}

export default ThirdUserTypes;
